import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NavigationStart } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {
  title = 'sai-adm-web';
  router: any;

  ngOnInit(): void {
  }
}
